import { ActionTypes } from "../Constants/ActionTypes";

const initialState = {
  fullPageLoading: false,
  contentLayoutLoading: false,
};

export const LoadingReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case ActionTypes.FULL_PAGE_LOADING:
      return {
        ...state,
        fullPageLoading: payload,
      };

    case ActionTypes.CONTENT_LAYOUT_LOADING:
      return {
        ...state,
        contentLayoutLoading: payload,
      };

    default:
      return state;
  }
};
